import React, { useEffect, useState } from "react";
import { Row } from "reactstrap";
import { usePromedioDiario } from "../../features/dashboard/hooks/usePromedioDiario";
import { Podium } from "../../features/dashboard/components/podium";
import logo from "../../assets/divine.webp";
import "../../CSS/inicio.css";
import { PodiumSkeleton } from "../../features/dashboard/components/podiumSkeleton";
import { podiumConfig } from "../../features/dashboard/constants";
import { Confetti } from "../../features/dashboard/components/confetti";

export default function Inicio() {
  const [usuario, setUsuario] = useState(null);
  const externo = usePromedioDiario("externo");
  const interno = usePromedioDiario("interno");
  const top3 = externo.promedio.slice(0, 3);
  const internoTop3 = interno.promedio.slice(0, 3);

  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const getUsuario = () => {
      const user = localStorage.getItem("@usuario");
      setUsuario(JSON.parse(user));
    };
    getUsuario();
  }, []);

  const podium = podiumConfig.map((config) => {
    const item = top3.find((_, index) => index + 1 === config.place);

    return {
      ...config,
      data: item,
    };
  });

  const internoPodium = podiumConfig.map((config) => {
    const item = internoTop3.find((_, index) => index + 1 === config.place);

    return {
      ...config,
      data: item,
    };
  });

  if (usuario && !usuario.externo && !usuario.interno) {
    return (
      <div className="titulo">
        <img height={94} width={94} src={logo} alt="logo" />
      </div>
    );
  }

  return (
    <div className="py-4">
      <h3 className="fw-bold text-center mb-5">Ranking de captura promedio</h3>
      {((showConfetti && !externo.isLoading && externo.promedio.length > 0) ||
        (showConfetti &&
          !interno.isLoading &&
          interno.promedio.length > 0)) && <Confetti />}

      {usuario && usuario.externo && (
        <Row className="justify-content-center align-items-end">
          <h4 className="fw-bold text-center">Externo</h4>
          {externo.isLoading
            ? podiumConfig.map((item) => (
                <PodiumSkeleton key={item.place} config={item} />
              ))
            : podium.map((item) => {
                const Icon = item.icon;
                return <Podium key={item.place} config={item} Icon={Icon} />;
              })}
        </Row>
      )}
      {usuario && usuario.interno && (
        <Row className="justify-content-center align-items-end mt-5">
          <h4 className="fw-bold text-center">Interno</h4>
          {interno.isLoading
            ? podiumConfig.map((item) => (
                <PodiumSkeleton key={item.place} config={item} />
              ))
            : internoPodium.map((item) => {
                const Icon = item.icon;
                return <Podium key={item.place} config={item} Icon={Icon} />;
              })}
        </Row>
      )}
    </div>
  );
}
